import {
  FormTab,
  Loading,
  TabbedForm,
  TextField,
  useNotify,
  useRedirect,
  useRefresh,
  useTranslate,
} from "react-admin";
import {
  GroupTitle,
  TransactionLogsField,
  TransactionNotesInput,
  TransactionNotesIsPrivateInput,
  useSaveMutation,
} from "ra-friendsofbabba";
import React, { Fragment } from "react";

import EvalInput from "./inputs/EvalInput";
import EvalSuggestionField from "./fields/EvalSuggestionField";
import Input from "../component/input/Input";
import { PrintButton } from "../component/button";
import Toolbar from "./Toolbar";
import { get } from "lodash";
import { makeStyles } from "@material-ui/core";
import transform from "./transform";
import useEvalConfig from "./useEvalConfig";

const useStyles = makeStyles((theme) => ({
  loader: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  tab: {
    "& div[class*=ra-input-research_project]": {
      display: "block",
      float: "left",
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    "& div[class*=ra-input-button]": {
      display: "block",
      clear: "both",
    },
    "& .MuiButtonBase-root.MuiButton-outlined:first-child": {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
    },
  },
}));
const Form = ({ create = false, permissions, ...props }) => {
  const evalConfig = useEvalConfig();
  const classes = useStyles();
  const isAdmin = permissions(["admin"]);
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const translate = useTranslate();
  const save = useSaveMutation({
    ...props,
    refresh: true,
    transform,
    onSuccess: (response, values) => {
      const prevState = get(values, "transaction.state");
      const nextState = get(response, "data.state");
      const isMoved = prevState !== nextState;
      notify(
        `resources.research-project-evals.messages.${values.state}_${
          isMoved ? "moved" : "loop"
        }.save_success`
      );
      if (values.id > 0) {
        refresh();
      } else {
        redirect("edit", props.basePath, response.data.id);
      }
    },
  });

  if (evalConfig.length === 0) {
    return <Loading className={classes.loader} />;
  }

  return (
    <TabbedForm
      {...props}
      save={save}
      redirect={false}
      initialValues={{
        is_private: false,
      }}
      toolbar={<Toolbar maxButtonsToDisplay={1} />}
    >
      <FormTab
        label="resources.research-project-evals.tabs.general"
        contentClassName={classes.tab}
      >
        <GroupTitle
          title={translate(
            "resources.research-project-evals.tabs.general.summary"
          )}
        />
        <TextField
          source="research_project.code"
          label={"resources.research-projects.fields.code"}
        />
        <TextField
          source="research_project.title"
          label={`resources.research-projects.fields.title`}
        />
        <TextField
          label={`resources.companies.fields.company_private`}
          source="research_project.partner.name"
        />
        <TextField
          source="research_project.company.company_type_entry.name"
          label={`resources.research-projects.fields.company_type_entry`}
        />
        <TextField
          source="research_project.company.operative_unit"
          label={`resources.research-projects.fields.operative_unit`}
        />

        <PrintButton
          source="button"
          sourceId="research_project_id"
          resource="research-projects"
          label="resources.research-project-evals.buttons.print_a1"
          variant="outlined"
          queryString={(record) => ({
            print: "a1",
            id: record?.research_project_id,
          })}
        />
        <Input
          config={evalConfig}
          source="research_project_eval_items"
          component={
            <EvalInput
              helperComponents={{
                111: ({ record }) => (
                  <EvalSuggestionField
                    caption="Descrizione del progetto di ricerca"
                    value={get(record, "research_project.description")}
                  />
                ),
                112: ({ record }) => (
                  <EvalSuggestionField
                    caption="Motivazioni"
                    value={get(record, "research_project.motivations")}
                  />
                ),
                121: ({ record }) => (
                  <Fragment>
                    <EvalSuggestionField
                      caption="Problematica/esigenza/criticità e rilevanza"
                      value={get(
                        record,
                        "research_project.problem_and_solution"
                      )}
                    />
                    <EvalSuggestionField
                      caption="Coerenza"
                      value={get(record, "research_project.coherence")}
                    />
                    <EvalSuggestionField
                      caption="Attività"
                      value={get(record, "research_project.activities")}
                    />
                  </Fragment>
                ),
              }}
            />
          }
        />
        {isAdmin && (
          <TransactionLogsField source="logs" admin={isAdmin} fullWidth />
        )}
        {isAdmin && <TransactionNotesInput source="notes" fullWidth />}
        {isAdmin && (
          <TransactionNotesIsPrivateInput
            admin={isAdmin}
            source="is_private"
            fullWidth
          />
        )}
      </FormTab>
    </TabbedForm>
  );
};
export default Form;
